import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { TokenService } from 'src/app/auth/services/token/token.service';
import { AuthenticationService } from '@auth/services/authentication/authentication.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const _token = inject(TokenService);
  const _auth = inject(AuthenticationService);

  const login = await _token.isValidLogin();
  if (!login) {
    _auth.logout();
    return false;
  }
  return true;
};
